(function () {
    'use strict';

    angular
        .module('ib-pmt-services-http-module')
        .factory('PmtStatesListProxy', PmtStatesListProxy);

    PmtStatesListProxy.$inject = ['$http', '$q'];
    function PmtStatesListProxy($http, $q) {
        var service = {
            getStatesList: getStatesList,
        };

        return service;

        ////////////////
        /**
         * Calls HTTP GET method on the get states list service
         * @param {string} url - the http url of the get states list rest service
         * @returns {Object.<Promise>} - returns the $http promise. When the promise resolves, it returns an object with the response data and the response status.
         *  When the promise rejects, it returns an object with the response error data and the response error code.
         */
        function getStatesList(url) {
            return $http.get(url).then(getStatesListComplete)['catch'](getStatesListFailed);

            function getStatesListComplete(response) {
                return { data: response.data, code: response.status };
            }

            function getStatesListFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();